import React, { useState } from 'react';

const ResultsSection = () => {
  const [hoveredRow, setHoveredRow] = useState(null);

  const metrics = [
    {
      icon: '/images/icons/ads.webp',
      label: 'ДРР',
      before: '15-38%',
      after: '3-8%',
      beforePercent: 75,
      afterPercent: 15,
      description: 'Доля рекламных расходов',
    },
    {
      icon: '/images/icons/conversion.webp',
      label: 'КОНВЕРСИЯ',
      before: '1-2%',
      after: '5-8%',
      beforePercent: 15,
      afterPercent: 70,
      description: 'Из карточки в корзину',
    },
    {
      icon: '/images/icons/roi.webp',
      label: 'ВОЗВРАТЫ',
      before: '15-25%',
      after: '3-7%',
      beforePercent: 60,
      afterPercent: 15,
      description: 'Процент возвратов',
    },
    {
      icon: '/images/icons/funnel.webp',
      label: 'ВЫРУЧКА',
      before: '2 млн ₽',
      after: '6 млн ₽',
      beforePercent: 33,
      afterPercent: 100,
      description: 'Ежемесячная выручка',
    },
  ];

  return (
    <section
      id="results"
      className="results-section"
      style={{
        background: '#0F0F1A',
        padding: '50px 0',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Декоративные элементы */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          zIndex: 1,
        }}
      >
        {/* Круг 1 - красный */}
        <div
          style={{
            position: 'absolute',
            width: '500px',
            height: '500px',
            top: '-200px',
            left: '-250px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #EF4444, #F97316)',
            filter: 'blur(120px)',
            opacity: 0.06,
          }}
        />

        {/* Круг 2 - градиент */}
        <div
          style={{
            position: 'absolute',
            width: '600px',
            height: '600px',
            bottom: '-250px',
            right: '-300px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, #22D3EE, #8B5CF6, #EC4899)',
            filter: 'blur(140px)',
            opacity: 0.08,
          }}
        />

        {/* Декоративные иконки на фоне с анимацией */}
        <img
                loading="lazy"
          src="/images/icons/chart.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '8%',
            left: '4%',
            transform: 'rotate(-15deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'float1 6s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/rocket.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            top: '12%',
            right: '5%',
            transform: 'rotate(12deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'float2 7s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/funnel.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '10%',
            left: '5%',
            transform: 'rotate(8deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'float3 5.5s ease-in-out infinite',
          }}
        />
        <img
                loading="lazy"
          src="/images/icons/analytics.webp"
          alt=""
          style={{
            position: 'absolute',
            width: '100px',
            height: '100px',
            bottom: '15%',
            right: '4%',
            transform: 'rotate(-10deg)',
            opacity: 0.05,
            filter: 'blur(1px) grayscale(0.3)',
            animation: 'float4 6.5s ease-in-out infinite',
          }}
        />
      </div>

      <div
        style={{
          maxWidth: '1000px',
          margin: '0 auto',
          padding: '0 24px',
          position: 'relative',
          zIndex: 2,
        }}
      >
        {/* Заголовок */}
        <div
          style={{
            textAlign: 'center',
            marginBottom: '60px',
          }}
        >
          <span
            style={{
              display: 'inline-block',
              background: 'rgba(255, 255, 255, 0.1)',
              color: '#FFFFFF',
              fontSize: '14px',
              fontWeight: 500,
              padding: '12px 24px',
              borderRadius: '50px',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              marginBottom: '24px',
            }}
          >
            РЕЗУЛЬТАТЫ
          </span>

          <h2
            style={{
              fontSize: '42px',
              fontWeight: 800,
              color: '#FFFFFF',
              textTransform: 'uppercase',
              lineHeight: 1.2,
              margin: '0 0 16px 0',
            }}
            className="results-title"
          >
            СЕЛЛЕР С ВЫРУЧКОЙ ДО{' '}
            <br className="results-title-br" />
            <span
              style={{
                background: 'linear-gradient(90deg, #22D3EE 0%, #EC4899 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              2 МЛН ₽/МЕС
            </span>
          </h2>

          <p
            style={{
              fontSize: '18px',
              fontWeight: 400,
              color: 'rgba(255, 255, 255, 0.6)',
              margin: 0,
            }}
            className="results-subtitle"
          >
            получает такие результаты за 3 месяца работы с нами
          </p>
        </div>

        {/* Метрики */}
        <div
          style={{
            background: 'rgba(255, 255, 255, 0.03)',
            border: '1px solid rgba(255, 255, 255, 0.08)',
            borderRadius: '24px',
            padding: '40px',
            marginBottom: '48px',
          }}
          className="results-card"
        >
          {metrics.map((metric, index) => (
            <div
              key={index}
              className="results-row"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '32px',
                padding: '24px 0',
                borderBottom: index < metrics.length - 1 ? '1px solid rgba(255, 255, 255, 0.06)' : 'none',
                transition: 'all 0.3s ease',
                background: hoveredRow === index ? 'rgba(255, 255, 255, 0.02)' : 'transparent',
                margin: hoveredRow === index ? '0 -20px' : '0',
                padding: hoveredRow === index ? '24px 20px' : '24px 0',
                borderRadius: hoveredRow === index ? '16px' : '0',
              }}
              onMouseEnter={() => setHoveredRow(index)}
              onMouseLeave={() => setHoveredRow(null)}
            >
              {/* Иконка и название */}
              <div
                className="results-label-wrap"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  minWidth: '220px',
                }}
              >
                <div
                  style={{
                    position: 'relative',
                  }}
                >
                  {/* Glow эффект */}
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      width: '80px',
                      height: '80px',
                      background: 'radial-gradient(circle, rgba(249, 115, 22, 0.3) 0%, rgba(236, 72, 153, 0.2) 40%, transparent 70%)',
                      filter: 'blur(15px)',
                      zIndex: -1,
                      pointerEvents: 'none',
                      opacity: hoveredRow === index ? 1 : 0.6,
                      transition: 'opacity 0.3s ease',
                    }}
                  />

                  <img
                loading="lazy"
                    src={metric.icon}
                    alt=""
                    style={{
                      width: '56px',
                      height: '56px',
                      objectFit: 'contain',
                      transform: hoveredRow === index ? 'scale(1.15) rotate(15deg)' : 'scale(1) rotate(0deg)',
                      transition: 'transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    }}
                  />
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                  }}
                >
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: 700,
                      color: '#FFFFFF',
                      textTransform: 'uppercase',
                    }}
                  >
                    {metric.label}
                  </span>
                  <span
                    style={{
                      fontSize: '13px',
                      fontWeight: 400,
                      color: 'rgba(255, 255, 255, 0.5)',
                    }}
                  >
                    {metric.description}
                  </span>
                </div>
              </div>

              {/* Шкала прогресса */}
              <div
                className="results-progress"
                style={{
                  flex: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                }}
              >
                {/* БЫЛО */}
                <div
                  className="results-before"
                  style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    justifyContent: 'flex-end',
                  }}
                >
                  <span className="results-mobile-label" style={{ display: 'none', fontSize: '11px', fontWeight: 600, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Было</span>
                  <span
                    className="results-value results-value-before"
                    style={{
                      fontSize: '20px',
                      fontWeight: 800,
                      color: '#EF4444',
                      minWidth: '90px',
                      textAlign: 'right',
                    }}
                  >
                    {metric.before}
                  </span>
                  <div
                    className="results-bar-track"
                    style={{
                      width: '120px',
                      height: '8px',
                      background: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: '4px',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        width: `${metric.beforePercent}%`,
                        height: '100%',
                        background: 'linear-gradient(90deg, #EF4444, #F97316)',
                        borderRadius: '4px',
                        transition: 'width 1s ease-out',
                      }}
                    />
                  </div>
                </div>

                {/* Стрелка */}
                <svg className="results-arrow" width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path
                    d="M6 16H26M26 16L20 10M26 16L20 22"
                    stroke="url(#arrow-grad)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <defs>
                    <linearGradient id="arrow-grad" x1="6" y1="16" x2="26" y2="16">
                      <stop stopColor="#22D3EE" />
                      <stop offset="1" stopColor="#EC4899" />
                    </linearGradient>
                  </defs>
                </svg>

                {/* СТАЛО */}
                <div
                  className="results-after"
                  style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    justifyContent: 'flex-start',
                  }}
                >
                  <span className="results-mobile-label" style={{ display: 'none', fontSize: '11px', fontWeight: 600, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Стало</span>
                  <div
                    className="results-bar-track"
                    style={{
                      width: '120px',
                      height: '8px',
                      background: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: '4px',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      style={{
                        width: `${metric.afterPercent}%`,
                        height: '100%',
                        background: 'linear-gradient(90deg, #22D3EE, #8B5CF6, #EC4899)',
                        borderRadius: '4px',
                        transition: 'width 1s ease-out',
                      }}
                    />
                  </div>
                  <span
                    className="results-value results-value-after"
                    style={{
                      fontSize: '20px',
                      fontWeight: 800,
                      background: 'linear-gradient(90deg, #22D3EE 0%, #EC4899 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      minWidth: '90px',
                      textAlign: 'left',
                    }}
                  >
                    {metric.after}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div
          style={{
            textAlign: 'center',
          }}
        >
          <button
            style={{
              background: 'linear-gradient(135deg, #F97316 0%, #EC4899 100%)',
              border: 'none',
              color: '#FFFFFF',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'uppercase',
              padding: '20px 48px',
              borderRadius: '50px',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
            }}
            onClick={() => window.dispatchEvent(new Event('openModal'))}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 12px 40px rgba(249, 115, 22, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            ХОЧУ ТАКИЕ ЖЕ РЕЗУЛЬТАТЫ →
          </button>
        </div>
      </div>

      {/* Анимации */}
      <style>
        {`
          .results-title-br { display: none; }

          @media (max-width: 768px) {
            .results-section { padding: 40px 0 !important; overflow: hidden !important; }
            .results-title { font-size: 26px !important; }
            .results-title-br { display: block !important; }
            .results-subtitle { font-size: 15px !important; }
            .results-card { padding: 12px !important; overflow: hidden !important; }
            .results-row { flex-direction: column !important; gap: 8px !important; align-items: stretch !important; padding: 12px 0 !important; margin: 0 !important; border-radius: 0 !important; }
            .results-label-wrap { min-width: auto !important; gap: 10px !important; }
            .results-label-wrap img { width: 40px !important; height: 40px !important; }
            .results-label-wrap span:first-of-type { font-size: 14px !important; }
            .results-label-wrap span:last-of-type { font-size: 12px !important; }
            .results-progress { flex-direction: column !important; gap: 6px !important; width: 100% !important; }
            .results-before, .results-after { flex: none !important; width: 100% !important; justify-content: flex-start !important; gap: 8px !important; flex-wrap: nowrap !important; }
            .results-mobile-label { display: inline !important; min-width: 36px !important; flex-shrink: 0 !important; }
            .results-value-before { min-width: auto !important; text-align: left !important; font-size: 15px !important; flex-shrink: 0 !important; }
            .results-value-after { min-width: auto !important; font-size: 15px !important; flex-shrink: 0 !important; }
            .results-bar-track { flex: 1 !important; width: auto !important; min-width: 0 !important; }
            .results-arrow { display: none !important; }
            .results-btn { padding: 16px 32px !important; font-size: 14px !important; }
            .results-bg-icon { display: none !important; }
          }
          @media (max-width: 480px) {
            .results-title { font-size: 22px !important; }
            .results-card { padding: 10px !important; }
            .results-value-before, .results-value-after { font-size: 14px !important; }
            .results-label-wrap img { width: 36px !important; height: 36px !important; }
          }

          @keyframes float1 {
            0%, 100% { transform: translate(0, 0) rotate(-15deg); }
            50% { transform: translate(-10px, -15px) rotate(-15deg); }
          }

          @keyframes float2 {
            0%, 100% { transform: translate(0, 0) rotate(12deg); }
            50% { transform: translate(10px, -20px) rotate(12deg); }
          }

          @keyframes float3 {
            0%, 100% { transform: translate(0, 0) rotate(8deg); }
            50% { transform: translate(-15px, -10px) rotate(8deg); }
          }

          @keyframes float4 {
            0%, 100% { transform: translate(0, 0) rotate(-10deg); }
            50% { transform: translate(15px, -15px) rotate(-10deg); }
          }

          /* Тонкая анимация для всех иконок */
          @keyframes iconFloat {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-5px); }
          }
        `}
      </style>
    </section>
  );
};

export default ResultsSection;
